
import Vue from 'vue';
import gql from 'graphql-tag';
import Multiselect from 'vue-multiselect';
import { IGroup } from '../store/insights';
import { hierarchySort } from '~shared/utils';

interface IData {
  options: string[];
  query: string;
  initialFetched: boolean;
  skipQuery: boolean;
}

export default Vue.extend({
  components: {
    Multiselect,
  },
  data(): IData {
    return {
      options: [],
      query: '',
      initialFetched: false,
      skipQuery: true,
    };
  },
  computed: {
    selectedGroup(): IGroup {
      return this.$store.state['insights'].filters.selectedGroup;
    },
  },
  async mounted(): Promise<void> {
    if (this.$route.query.group) {
      // Group id present in the query, fetch group and set it
      try {
        this.initialFetched = true;
        const result = await this.$apollo.query({
          query: gql`
            query($id: ID!) {
              Group(id: $id) {
                id
                name
                currency
                meta {
                  parents {
                    id
                    name
                    parentId
                  }
                }
              }
            }
          `,
          variables: {
            id: this.$route.query.group,
          },
        });
        if (result.data && result.data.Group) {
          this.$store.dispatch('insights/setSelectedGroup', result.data.Group);
        }
      } catch (e) {
        if (e.message === 'GraphQL error: Permission denied.') {
          this.$snotify.error('You do not have access to this publisher.');
        } else {
          this.$snotify.error(e.message);
        }
      }
    }
    this.skipQuery = false;
  },
  methods: {
    async setGroup(v): Promise<void> {
      if (v && v.id != this.$route.query.group) {
        await this.$router.push({
          query: Object.assign({}, this.$route.query, {
            group: v.id,
          }),
        });
        this.$store.dispatch('insights/setClearWidgets', true);
      }
      this.$store.dispatch('insights/setSelectedGroup', v);
    },
    search(q: string): void {
      this.query = q;
    },
    hierarchySort,
  },
  apollo: {
    options: {
      query: gql`
        query($query: String!) {
          Groups(query: $query) {
            groups {
              id
              name
              currency
              meta {
                parents {
                  id
                  name
                  parentId
                }
              }
            }
          }
        }
      `,
      variables(): { query: string } {
        return {
          query: this.query,
        };
      },
      update(data): [] {
        if (
          data &&
          data.Groups &&
          data.Groups.groups &&
          data.Groups.groups.length
        ) {
          if (!this.initialFetched) {
            let currentGroup = data.Groups.groups[0];
            this.setGroup(currentGroup);
            this.initialFetched = true;
          }
          return data.Groups.groups;
        }
        return [];
      },
      skip(): boolean {
        return this.skipQuery;
      },
      fetchPolicy: 'network-only',
      throttle: 1000,
    },
  },
});
